import { render, staticRenderFns } from "./receiversBill.vue?vue&type=template&id=214999c2&scoped=true&"
import script from "./receiversBill.vue?vue&type=script&lang=js&"
export * from "./receiversBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214999c2",
  null
  
)

export default component.exports